import React from 'react';
import {useStyles} from "./ShowDeliveryStepStatus.style";
import clsx from "clsx";
import {Tooltip} from "@material-ui/core";
import ShowDeliveryStepStatusProperties from "./ShowDeliveryStepStatusProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import DeliveryStepStatus from '../../../entities/DeliveryStepStatus';
import { LocalShipping, Place } from "@mui/icons-material";


const ShowDeliveryStepStatus: React.FC<ShowDeliveryStepStatusProperties> = ({
                                                                  status,
                                                                  className = '',
                                                                  tooltip,
                                                                  label,
                                                              }) => {
    const classes = useStyles();
    const i18n = useI18nContext();
    if (!status) return <></>

    const getIcon = () => {
        switch (status) {
            case DeliveryStepStatus.IN_PROGRESS:
                return <LocalShipping/>;
            case DeliveryStepStatus.DELIVERED:
                return <CheckCircleIcon/>;
            case DeliveryStepStatus.RECEIVED:
                return <Place/>;
            case DeliveryStepStatus.PENDING:
                return <HourglassBottomIcon/>;
        }
    }
    const getClass = () => {
        switch (status) {
            case DeliveryStepStatus.DELIVERED:
                return classes.success;
            case DeliveryStepStatus.PENDING:
                return classes.pending;
            case DeliveryStepStatus.IN_PROGRESS:
            case DeliveryStepStatus.RECEIVED:
                return classes.warning;
        }
    }

    return (
        <Tooltip title={tooltip || ""}>
            <div className={clsx(classes.display_field_container, className, getClass())}>
                <div className={classes.value}>
                    {getIcon()}
                    {i18n.translate(`${status}`)}
                </div>
            </div>
        </Tooltip>
    )
}
export default ShowDeliveryStepStatus;